import * as React from "react"

export const LoadingPlaceHolder = (): JSX.Element => (
    <div className="is-loading is-placeholder">
        <div className="theme-thumb bg-cloud"></div>
        <div className="theme-thumb bg-cloud"></div>
        <div className="theme-thumb bg-cloud"></div>
    </div>
)

export default LoadingPlaceHolder
